import {useProperty} from '@olympeio/core';
import {requestStores} from '../../ListOfPREditors.brick.jsx';
import {buildEditabilityContext, getDisableReasons, isFieldDisabled} from './fieldEditability';

/**
 * Reads lock, access, and source from the request store and exposes field disable checks.
 * The current tab comes from `options.tab` or from the brick property `Current tab`.
 * @param {string} prTag
 * @param {{context?: *, tab?: string, material?: Object}} [options]
 * @return {{isDisabled: function(string): boolean, getReasons: function(string): string[], tab: *}}
 */
export function useFieldEditability(prTag, options = {}) {
    const {context, tab, material} = options;
    const tabFromProperty = useProperty(context, 'Current tab', false);
    const resolvedTab = tab ?? tabFromProperty;

    const useRequestStore = requestStores.get(prTag);
    const prLocked = useRequestStore((state) => state.prLocked);
    const userHasAccessToProperties = useRequestStore((state) => state.userHasAccessToProperties);
    const source = useRequestStore((state) => state.source);
    const sourceToDisplay = useRequestStore((state) => state.sourceToDisplay);
    const wayOfBuying = useRequestStore((state) => state.wayOfBuying);

    const ctx = buildEditabilityContext({
        store: {
            prLocked,
            userHasAccessToProperties,
            source,
            sourceToDisplay,
            wayOfBuying,
        },
        tab: resolvedTab,
        material,
    });

    return {
        isDisabled(fieldId) {
            return isFieldDisabled(fieldId, ctx);
        },
        getReasons(fieldId) {
            return getDisableReasons(fieldId, ctx);
        },
        tab: resolvedTab,
    };
}
